/**
 * EmptyState — Componente de estado vacío con la mascota FIBI.
 * Field Intelligence Bot for Internet
 */
import RobotMascot from "./RobotMascot";

export default function EmptyState({ title, description, action, variant = "idle", size = "md" }) {
  const robotSize = size === "lg" ? 160 : size === "sm" ? 80 : 120;
  return (
    <div className="text-center py-12 px-4" data-testid="empty-state">
      <div className="inline-block float-slow mb-4">
        <RobotMascot size={robotSize} variant={variant} />
      </div>
      <h3 className="text-xl font-bold text-gray-900 mb-2" style={{ fontFamily: "Space Grotesk" }}>
        {title || "FIBI no encontró nada por aquí"}
      </h3>
      {description && (
        <p className="text-sm text-gray-600 max-w-md mx-auto mb-5 leading-relaxed">{description}</p>
      )}
      {action && <div className="flex justify-center">{action}</div>}
      <div className="mt-6 text-[10px] uppercase tracking-[0.25em] font-mono text-gray-400">
        FIBI · Field Intelligence Bot for Internet
      </div>
    </div>
  );
}
